/*
 * 作者: Fultom
 * 创建时间: 2021-03-02 15:59:00
 * 最近修改时间: 2024-01-09 16:57:15
 * 功能:
 */
import Cookies from 'js-cookie'
import store from '@/store'
const TokenKey = 'token';

export function getToken() {
  // let token = '';
  // let token = Cookies.get(TokenKey)||JSON.parse(localStorage.getItem('user')).user_token || '';
  let token = sessionStorage.getItem('user_token') || localStorage.getItem('user_token');

  if (!token) {
    let userInfo = localStorage.getItem('user');
    if (userInfo) {
      token = JSON.parse(userInfo).user_token || '';
    } else {
      token = Cookies.get(TokenKey) || '';
    }
  }

  return token
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}


export function getOpenId() {
  return Cookies.get('openid')
}

export function getCookie(name) {
  let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  return (arr = document.cookie.match(reg)) ? unescape(arr[2]) : null;
}

export function clearAllCookie() {
  const keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    for (let i = keys.length; i--;)
      document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString() + ';domain=zhibobao.com'
  }
}



export function isExperience() {
  if (store.getters.userInfo.uid === store.getters.experience.uid) {
    return true
  }
  return false
}






// WEBPACK FOOTER //
// ./src/utils/auth.js